const SORTS_DIRECTION = {
    ASCENDING: 'ASCENDING',
    DESCENDING: 'DESCENDING'
}

export default SORTS_DIRECTION;